$(document).ready(function () {
    // header drawer code start
    $("button.mobileMenuOpener").click(function () {
        $("#mobile-header").toggleClass("mobileMenuOpen");
        $(".header--classic").toggleClass("mobileMenuIsOpen");
        $("html, body").toggleClass("hideScroll");
    });
    var mobileDropDownIcon = $(".mobDropDownIcon").html();
    $("ul.mobile-menu__list span.close-dropdown").html(mobileDropDownIcon);
    // header drawer code start

    // footer toggleButton css code start 
    $(".footer__menu  p.footer__heading").click(function(){
      $(this).parent(".footer__menu").toggleClass("showContent");
    });

    

    // play/pause video code start 
    $('button.videoPlayBtn').click(function () {
        var $parentContainer = $(this).closest(".videoItemContainer");
        $(".videoItemContainer").not($parentContainer).removeClass("playingVideo");
        $parentContainer.toggleClass("playingVideo");

        var videoId = $(this).data('id');
        var video = $(videoId)[0]; // Select the video element using the ID

        $('video').not(video).each(function () {
            this.pause(); // Pause other videos
        });

        if (video.paused) {
            video.play(); // Play the clicked video
        } else {
            video.pause(); // Pause the clicked video
        }

    });

    // play/pause video code end 

    // Update price and variant images of product thumbnail on variant change code start 
    $('.quickAddEnable  .swatch input').on('click', function () {
        var clickedInput = this;
        setTimeout(function () {
            var grandVariantParent = $(clickedInput).parent(".swatch__option").parent(".swatch__options").parent(".swatch").parent(".radioBtns").parent("options-selection").parent(".variant-selection").attr('variant'); //we are getting selected variant id from variant-selection tag's attribute which is already located in quidkAddToCartForm Snippet
            var currentVariantPrice = $("#" + grandVariantParent + "-price").html(); // we are getting selected variant price html from quickADDtoCartForm Snippet 
            var productMainId = $("#" + grandVariantParent + "-price").attr("data-prod"); // we are getting Product Id from attribute of Variant price tag located in same snippet
            $(productMainId + "-MainPrice").html(currentVariantPrice); // Just Updating Price Tag Html which is located in product-thumbnail-info snippet(original thumbnail Price)

            // variant images display code start
            $(productMainId + "-variantImg").show();//variant images container which is also containing class (prodVariantImg)  located in produt-thumbnail.liquid snippet


            if ($("#" + grandVariantParent + "-img").length != 0) {
                $(productMainId + "-variantImg img").hide();
                $("#" + grandVariantParent + "-img").show();
            }
            else {
                $(productMainId + "-variantImg img").hide();
                $(productMainId + "-img").show();
            }


        }, 600);
    });
    // Update price and variant images  of product thumbnail on variant change code end 

    // collection custom Sorting dropdown 

    // custom collection sorting dropdown code start
    $(".dropDownBtn").click(function () {
        $(this).parent(".filterCustomDropDown").toggleClass("activeDropDown");
    });


    $(".sortingBtnNew").click(function () {
        let dataVal = $(this).attr("data-val");
        let thisText = $(this).text();
        $("#sort-by").val(dataVal).trigger("change");
        $(".sortingBtnNew").removeClass("activeSort");
        $(this).addClass("activeSort");
        $(".filterCustomDropDown").removeClass("activeDropDown");

        $(this)
            .parent(".dropDownItem")
            .prev(".dropDownBtn")
            .children(".btnTxt")
            .text(thisText);
    });

    // custom collection sorting dropdown code end

    // product page side tabs code start 
    $(".tabBtn").click(function(){
        $(this).toggleClass("activeTab");
        $(this).next(".tabContentTxt").slideToggle(400);
    });
    // product page side tabs code end 

    $("a.forgotPassWordLink").click(function(){
        $(".account-page__header").hide();
    });
    $(".cancel-recover-password ").click(function(){
        $(".account-page__header").show();
    });

    
// before after slider code start
function beforAndAfterSection() {
    const beforeItemSection = document.querySelectorAll(".beforeAfterSlider");
    const beforeItemContainer = [...beforeItemSection];
  
    beforeItemContainer.forEach((slider) => {
      const before = slider.querySelector(".beforeItem");
      const beforeImage = before.getElementsByTagName("img")[0];
      const beforeAfterResizer = slider.querySelector(".beforeAfterResizer");
  
      let active = false;
  
      //Sort overflow out for Overlay Image
        let width = slider.offsetWidth;
        console.log(width);
        beforeImage.style.width = width + "px";
       
      //Adjust width of image on resize
      window.addEventListener("resize", function () {
        let width = slider.offsetWidth;
        console.log(width);
        beforeImage.style.width = width + "px";
      });
  
      beforeAfterResizer.addEventListener("mousedown", function () {
        active = true;
        beforeAfterResizer.classList.add("resize");
      });
  
      document.body.addEventListener("mouseup", function () {
        active = false;
        beforeAfterResizer.classList.remove("resize");
      });
  
      document.body.addEventListener("mouseleave", function () {
        active = false;
        beforeAfterResizer.classList.remove("resize");
      });
  
      document.body.addEventListener("mousemove", function (e) {
        if (!active) return;
        let x = e.pageX;
        x -= slider.getBoundingClientRect().left;
        slideIt(x);
        pauseEvent(e);
      });
  
      beforeAfterResizer.addEventListener("touchstart", function () {
        active = true;
        beforeAfterResizer.classList.add("resize");
      });
  
      document.body.addEventListener("touchend", function () {
        active = false;
        beforeAfterResizer.classList.remove("resize");
      });
  
      document.body.addEventListener("touchcancel", function () {
        active = false;
        beforeAfterResizer.classList.remove("resize");
      });
  
      //calculation for dragging on touch devices
      document.body.addEventListener("touchmove", function (e) {
        if (!active) return;
        let x;
  
        let i;
        for (i = 0; i < e.changedTouches.length; i++) {
          x = e.changedTouches[i].pageX;
        }
  
        x -= slider.getBoundingClientRect().left;
        slideIt(x);
        pauseEvent(e);
      });
  
      function slideIt(x) {
        let transform = Math.max(0, Math.min(x, slider.offsetWidth));
        before.style.width = transform + "px";
        beforeAfterResizer.style.left = transform - 0 + "px";
      }
  
      //stop divs being selected.
      function pauseEvent(e) {
        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
      }
    });
  
  }
  beforAndAfterSection()
  
  // before after slider code end

});

